var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("div", { staticClass: "page-cnt" }, [
        _c(
          "div",
          { staticClass: "left-sidebar ex-has-btm" },
          [
            _vm.renderSearchTour && !_vm.nonTravelGroupTypeId
              ? _c(
                  "SearchTour",
                  {
                    ref: "childSearchTour",
                    attrs: {
                      groupType: _vm.groupType,
                      listVouchers: _vm.listVouchers,
                      setErrorMessage: _vm.setErrorMessage,
                      updateTourInfo: _vm.updateTourInfo
                    },
                    on: { closedTour: _vm.closedTour }
                  },
                  [
                    _c("BizPrePaidCard", {
                      attrs: {
                        showUseBizPrePaidCard: _vm.showUseBizPrePaidCard
                      },
                      model: {
                        value: _vm.selectedBizPrePaidCard,
                        callback: function($$v) {
                          _vm.selectedBizPrePaidCard = $$v
                        },
                        expression: "selectedBizPrePaidCard"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "content-wallet mt-4" }, [
              _vm.groupType == _vm.constants.GroupVoucherType.cash_detail
                ? _c("ul", { staticClass: "nav nav-tabs" }, [
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link",
                          class: {
                            active:
                              _vm.screenType == _vm.constants.CashScreenType
                          },
                          on: {
                            click: function($event) {
                              return _vm.switchScreen(
                                _vm.cashId,
                                _vm.currencyId,
                                _vm.constants.CashScreenType
                              )
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "icon-wallet mr-2" }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("cash.list_carry")) +
                              "\n                            "
                          ),
                          _c("span", { staticClass: "hidden-lap" }, [
                            _vm._v(_vm._s(_vm.$t("cash.balance_payments")))
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link",
                          class: {
                            active:
                              _vm.screenType ==
                              _vm.constants.LocalIncomeScreenType
                          },
                          on: {
                            click: function($event) {
                              return _vm.switchScreen(
                                _vm.cashId,
                                _vm.currencyId,
                                _vm.constants.LocalIncomeScreenType
                              )
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "icon-file mr-2" }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("cash.local_income")) +
                              "\n                        "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.tourInfo.tour_type == _vm.foreignType
                      ? _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              class: {
                                active:
                                  _vm.screenType ==
                                  _vm.constants.ExchangeScreenType
                              },
                              on: {
                                click: function($event) {
                                  return _vm.switchScreen(
                                    _vm.cashId,
                                    _vm.currencyId,
                                    _vm.constants.ExchangeScreenType
                                  )
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "icon-yen mr-2" }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("cash.exchange")) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "tab-content" }, [
                _c(
                  "div",
                  { staticClass: "tab-pane active", attrs: { id: "balance" } },
                  [
                    _vm.cashDetails.cash_currency &&
                    _vm.screenType == _vm.constants.CashScreenType
                      ? _c("cash-summary", {
                          attrs: {
                            cashDetails: _vm.cashDetails,
                            onChangeCashDetails: _vm.onChangeCashDetails,
                            slickOptions: _vm.slickOptions,
                            useBizPrePaidCard: _vm.useBizPrePaidCard
                          }
                        })
                      : _vm.cashDetails.cash_currency &&
                        _vm.isShowIncomeSummary &&
                        _vm.screenType == _vm.constants.LocalIncomeScreenType
                      ? _c("income-summary", {
                          ref: "income_summary",
                          attrs: {
                            summarys: _vm.summarys,
                            tourInfo: _vm.tourInfo,
                            slickOptions: _vm.summarySlickOptions
                          }
                        })
                      : _vm.cashDetails.cash_currency &&
                        _vm.isShowExchangeSummary &&
                        _vm.screenType == _vm.constants.ExchangeScreenType
                      ? _c("exchange-summary", {
                          ref: "exchange_summary",
                          attrs: {
                            summarys: _vm.summarys,
                            slickOptions: _vm.summarySlickOptions
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "heading-breadcrumb" }, [
                      _vm._v(_vm._s(_vm.getBreadCrumb()))
                    ]),
                    _vm._v(" "),
                    !_vm.nonTravelGroupTypeId
                      ? _c(
                          "ul",
                          { staticClass: "nav nav-tabs" },
                          _vm._l(_vm.voucherTabs, function(tab) {
                            return _c(
                              "li",
                              {
                                key: tab.voucherTypeId,
                                staticClass: "nav-item"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link",
                                    class: {
                                      active:
                                        _vm.activeVoucherTab ==
                                        tab.voucherTypeId,
                                      disabled: !tab.canBeActive
                                    },
                                    on: {
                                      click: function($event) {
                                        tab.canBeActive &&
                                          (_vm.activeVoucherTab =
                                            tab.voucherTypeId)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(tab.name) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.voucherLists[_vm.activeVoucherTab]
                      ? _c(
                          "div",
                          { staticClass: "table-static" },
                          _vm._l(
                            _vm.voucherLists[_vm.activeVoucherTab],
                            function(voucherList, groupMonth, index) {
                              return _c("div", { key: index }, [
                                _vm.fiscalYearLabels[groupMonth]
                                  ? _c(
                                      "div",
                                      { staticClass: "nta-fiscal-year" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.fiscalYearLabels[groupMonth]
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "table-heading mt-10" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dateUtils.formatDateYYYYMM(
                                          groupMonth
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "table-cnt" }, [
                                  _c(
                                    "ul",
                                    { staticClass: "lst-static" },
                                    _vm._l(voucherList, function(voucher) {
                                      return _c(
                                        "li",
                                        {
                                          key: voucher.id,
                                          class: {
                                            "ex-highlight-row":
                                              _vm.activeVoucher == voucher.id
                                          },
                                          on: {
                                            click: function(e) {
                                              if (
                                                _vm.activeVoucher != voucher.id
                                              ) {
                                                _vm.voucherDetails(voucher.id)
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _c("voucher-row", {
                                            attrs: {
                                              screenType: _vm.screenType,
                                              voucher: voucher,
                                              isExchange:
                                                _vm.screenType ==
                                                _vm.constants.ExchangeScreenType
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                ])
                              ])
                            }
                          ),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _vm.groupType != _vm.constants.GroupVoucherType.cash_detail
              ? _c("div", { staticClass: "btns-btm" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center pl-3 pr-3"
                    },
                    [
                      _c("div", { staticClass: "row no-gutters w-100" }, [
                        _c("div", { staticClass: "col-12 pl-1 pr-1" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-pink-44 w-100 ex-orange-light",
                              attrs: { "data-toggle": "modal" },
                              on: { click: _vm.addVoucherFromTab }
                            },
                            [
                              _c("i", { staticClass: "icon-camera mr-2" }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("voucher.button.add_details")) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.screenType == _vm.constants.ExchangeScreenType
              ? _c("div", { staticClass: "btns-btm" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center pl-3 pr-3"
                    },
                    [
                      _c("div", { staticClass: "row no-gutters w-100" }, [
                        _c("div", { staticClass: "col-6 pl-1 pr-1" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-pink-44 w-100 ex-orange-light",
                              attrs: { "data-toggle": "modal" },
                              on: { click: _vm.addVoucherCamera }
                            },
                            [
                              _c("i", { staticClass: "icon-camera mr-2" }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("voucher.button.add_details")) +
                                  "\n                            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 pr-1 pl-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-pink-44 w-100 ex-orange",
                              attrs: { "data-toggle": "modal" },
                              on: { click: _vm.addVoucherManual }
                            },
                            [
                              _c("i", { staticClass: "icon-pen mr-2" }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("voucher.button.manual_input")
                                  ) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.screenType == _vm.constants.CashScreenType ||
            _vm.screenType == _vm.constants.LocalIncomeScreenType
              ? _c("div", { staticClass: "btns-btm" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center pl-3 pr-3"
                    },
                    [
                      _c("div", { staticClass: "row no-gutters w-100" }, [
                        _c("div", { staticClass: "col-4 pl-1 pr-1" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-pink-44 w-100 ex-orange-light",
                              attrs: { "data-toggle": "modal" },
                              on: { click: _vm.addVoucherCamera }
                            },
                            [
                              _c("i", { staticClass: "icon-camera mr-2" }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("voucher.button.add_details")) +
                                  "\n                            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 pr-1 pl-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-pink-44 w-100 ex-orange",
                              attrs: { "data-toggle": "modal" },
                              on: { click: _vm.addVoucherManual }
                            },
                            [
                              _c("i", { staticClass: "icon-pen mr-2" }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t("voucher.button.manual_input")
                                  ) +
                                  "\n                            "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4 pl-1 pr-1" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-pink-44 w-100 ex-border",
                              on: { click: _vm.onClickOfficialRegisterBtn }
                            },
                            [
                              _c("i", { staticClass: "icon-upload mr-2" }),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      _vm.utils.isCooperator()
                                        ? "voucher.button.preview"
                                        : "voucher.button.official_registration"
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "main-cnt" }, [
          _c(
            "div",
            { staticClass: "content-white" },
            [
              !_vm.nonTravelGroupTypeId
                ? _c("TourInfo", {
                    attrs: {
                      setErrorMessage: _vm.setErrorMessage,
                      tourInfoProp: _vm.tourInfo
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.errorMessage
                ? _c("div", { staticClass: "error-message-voucher" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("i", { staticClass: "icon-warning mr-2" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "errror-txt" }, [
                        _c("p", { staticClass: "fs-14 text-red font600" }, [
                          _vm._v(_vm._s(_vm.$t("error.title")))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "fs-14 text-red font600" }, [
                          _vm._v(_vm._s(_vm.errorMessage))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isNotTour,
                            expression: "isNotTour"
                          }
                        ],
                        staticStyle: { float: "right" },
                        attrs: { href: "#" },
                        on: { click: _vm.setIsClosed }
                      },
                      [_vm._v("締切済ツアーも対象として再検索")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.modeDetails
                ? _c(
                    "div",
                    { staticClass: "content-body" },
                    [
                      _c("div", { staticClass: "d-flex" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-pink-53 w140 mr-3",
                            attrs: { disabled: !_vm.buttonEnabled },
                            on: {
                              click: function($event) {
                                _vm.buttonEnabled && _vm.editVoucher()
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "icon-edit-w mr-2" }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("button.edit")) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-gray-53 w140",
                            attrs: {
                              "data-toggle": "modal",
                              "data-target": "#modalDelete",
                              disabled:
                                _vm.utils.isReadOnly() ||
                                !_vm.canDelete(
                                  _vm.voucher.voucher_type_id,
                                  _vm.voucher
                                )
                            }
                          },
                          [
                            _c("i", { staticClass: "icon-trash mr-2" }),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("button.delete")) +
                                "\n                        "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(_vm.componentDetailsVoucher, {
                        tag: "component",
                        attrs: { voucher: _vm.voucher },
                        on: { "select-update-files": _vm.selectUpdateFiles }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.modeAdd
                ? _c(
                    "div",
                    { staticClass: "content-body" },
                    [
                      _c(_vm.componentAddVoucher, {
                        ref: "addComponent",
                        tag: "component",
                        attrs: {
                          setErrorMessage: _vm.setErrorMessage,
                          voucherParams: _vm.voucherParams
                        },
                        on: {
                          voucherSuccess: _vm.voucherSuccess,
                          cancelAdd: _vm.reset,
                          showPreInputCopyModal: _vm.showPreInputCopyModal
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.modeEdit
                ? _c(
                    "div",
                    { staticClass: "content-body" },
                    [
                      _c(_vm.componentEditVoucher, {
                        tag: "component",
                        attrs: {
                          setErrorMessage: _vm.setErrorMessage,
                          voucherParams: _vm.voucherParams
                        },
                        on: {
                          voucherSuccess: _vm.voucherSuccess,
                          cancelAdd: _vm.reset
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.previewFileUpload
                ? _c(
                    "div",
                    { staticClass: "content-body" },
                    [
                      _c("preview-file-upload", {
                        key: _vm.num,
                        attrs: {
                          selectFiles: _vm.selectFiles,
                          modeAddVoucher: _vm.isAddVoucher,
                          cancelUpload: _vm.reset,
                          uploadFiles: _vm.uploadFiles,
                          showThumb: _vm.showThumb,
                          setErrorMessage: _vm.setErrorMessage,
                          voucherType: _vm.voucherType
                        },
                        on: {
                          "update:uploadFiles": function($event) {
                            _vm.uploadFiles = $event
                          },
                          "update:upload-files": function($event) {
                            _vm.uploadFiles = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("DeleteVoucher", {
        attrs: {
          id: _vm.voucher.id,
          getCashDetails: _vm.getCashDetails,
          listVouchers: _vm.listVouchers,
          groupType: _vm.groupType,
          setErrorMessage: _vm.setErrorMessage,
          reset: _vm.reset
        }
      }),
      _vm._v(" "),
      _c("SelectVoucherTypeModal", {
        ref: "selectVoucherModal",
        attrs: {
          setVoucherType: _vm.setVoucherType,
          screenType: _vm.screenType,
          groupType: _vm.groupType,
          selectFiles: _vm.selectFiles,
          tourInfo: _vm.tourInfo,
          useBizPrePaidCard: _vm.useBizPrePaidCard
        }
      }),
      _vm._v(" "),
      _c("show-img", {
        attrs: { setListFiles: _vm.setListFiles, file: _vm.file }
      }),
      _vm._v(" "),
      _c("upload-file-modal", {
        attrs: {
          modalId: "uploadFileModal",
          previewFiles: _vm.previewFiles,
          setListFiles: _vm.setListFiles,
          uploadFiles: _vm.uploadFiles,
          beforeCnt: _vm.beforeCnt
        }
      }),
      _vm._v(" "),
      _c("upload-file-modal", {
        attrs: {
          modalId: "updateFileModal",
          afterCheckPwdPdf: _vm.updateFiles,
          previewFiles: _vm.previewFiles,
          setListFiles: _vm.setListFiles,
          uploadFiles: _vm.uploadFiles,
          beforeCnt: _vm.beforeCnt
        }
      }),
      _vm._v(" "),
      _c("pre-input-copy", {
        ref: "preInputCopy",
        on: { setVoucher: _vm.setVoucher }
      }),
      _vm._v(" "),
      _c("confirm-register-modal", {
        ref: "confirmRegister",
        attrs: {
          summarys: _vm.summarys,
          summarySlickOptions: _vm.summarySlickOptions,
          tourInfo: _vm.utils.isCooperator() ? _vm.tourInfo : _vm.editTourInfo
        },
        on: {
          downloadExcel: _vm.downloadExcel,
          exportExcel: _vm.exportExcel,
          backEditTourInfo: _vm.backEditTourInfo,
          onClickCancel: _vm.onClickCancel
        }
      }),
      _vm._v(" "),
      _c("edit-tour-info-modal", {
        ref: "editTour",
        on: { confirmRegister: _vm.nextOfficialRegistration }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "successRegister",
            "modal-class": "modal fade modal-upload",
            "hide-header": "",
            "hide-footer": ""
          },
          on: { hidden: _vm.exportExcelSuccess }
        },
        [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("successRegister")
                }
              }
            },
            [_vm._v("×")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "center-modal" }, [
            _c(
              "div",
              {
                staticClass: "center-ttl font300 d-flex justify-content-center"
              },
              [
                _c("i", { staticClass: "icon-upload-orange mr-2" }),
                _vm._v(" "),
                _c("span", { staticClass: "font500 text-pink" }, [
                  _vm._v(_vm._s(_vm.msgExportExcel))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-4 text-center" }, [
              _c("i", {
                class: _vm.isExportExcelSuccess
                  ? "icon-checked-circle"
                  : "icon-failed-circle"
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal fade modal-upload",
          attrs: {
            id: "errorDownloadExcel",
            "hide-header": "",
            "hide-footer": ""
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "close",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("errorDownloadExcel")
                }
              }
            },
            [_vm._v("×")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "center-modal" }, [
            _c(
              "div",
              {
                staticClass: "center-ttl font300 d-flex justify-content-center"
              },
              [
                _c("i", { staticClass: "icon-error-preview mr-2" }),
                _vm._v(" "),
                _c("span", { staticClass: "font500 text-pink" }, [
                  _vm._v(_vm._s(_vm.msgErrorDownloadExcel))
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "modal fade",
          attrs: {
            id: "confirmNoPaymentRegister",
            centered: "",
            "hide-header": "",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          model: {
            value: _vm.isConfirmNoPaymentRegisterModalActive,
            callback: function($$v) {
              _vm.isConfirmNoPaymentRegisterModalActive = $$v
            },
            expression: "isConfirmNoPaymentRegisterModalActive"
          }
        },
        [
          !_vm.isCancelConfirm
            ? _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$bvModal.hide("confirmNoPaymentRegister")
                    }
                  }
                },
                [_vm._v("×")]
              )
            : _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.showConfirmRegsiter()
                      _vm.$bvModal.hide("confirmNoPaymentRegister")
                    }
                  }
                },
                [_vm._v("×")]
              ),
          _vm._v(" "),
          _c("div", { staticClass: "center-modal" }, [
            !_vm.isCancelConfirm
              ? _c(
                  "div",
                  {
                    staticClass:
                      "center-ttl font300 d-flex justify-content-center"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "voucher.modal-confirmNoPaymentRegister.message_no_data"
                          )
                        ) +
                        " "
                    ),
                    _c("br"),
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.utils.isCooperator()
                            ? _vm.$t(
                                "voucher.modal-confirmNoPaymentRegister.message_preview"
                              )
                            : _vm.$t(
                                "voucher.modal-confirmNoPaymentRegister.message_confirm"
                              )
                        ) +
                        "\n            "
                    )
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "center-ttl",
                    staticStyle: { "text-align": "center" }
                  },
                  [
                    _c("div", { staticClass: "font500" }, [
                      _vm._v(
                        "\n                    本登録作業を中止しますか？\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          "font-weight": "300"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    団体情報修正内容は破棄されますのでご注意ください。"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                    確認画面に戻る場合は、この画面を×で閉じてください\n                "
                        )
                      ]
                    )
                  ]
                ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              !_vm.isCancelConfirm
                ? _c("div", { staticClass: "pr-2 w-165" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-pink-53 w-100",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickNoPaymentRegister }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("button.ok")) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                : _c("div", { staticClass: "pr-2 w-165" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-pink-53 w-100",
                        attrs: { type: "button" },
                        on: { click: _vm.onClickNoPaymentRegister }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("button.cancelRegister")) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
              _vm._v(" "),
              !_vm.isCancelConfirm
                ? _c("div", { staticClass: "pl-2 w-165" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-gray-53 w-100",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.$bvModal.hide("confirmNoPaymentRegister")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("button.cancel")) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a9be1dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a9be1dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/pc/Voucher/List.vue
// module id = null
// module chunks = 